import type { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';

import type { BaseProps, ForwardProps } from '../../types';
import { defaultThemeProp } from '../../theme';

export interface LineSkeletonProps extends BaseProps {
  /**
   * Width of the skeleton.
   * @default 'default'
   */
  width?: 'default' | 'l' | 'm' | 's';
  /**
   * Variant of the skeleton.
   * @default 'default'
   */
  variant?: 'default' | 'link';
}

const defaultProps: Partial<LineSkeletonProps> = {
  width: 'default',
  variant: 'default'
};

const lengthToPercent = {
  default: 'auto',
  l: '80%',
  m: '50%',
  s: '30%'
};

export const StyledLineSkeleton = styled.div<Partial<LineSkeletonProps>>(props => {
  const { width, variant } = props;
  const { skeleton: skeletonBackground } = props.theme.base.palette;
  const lengthPercent = lengthToPercent[width || 'default'];
  const LinkHeaderColor = 'rgb(135,206,235,0.5)';
  return css`
    flex-grow: 1;
    margin: 0.25rem;
    height: 0.875rem;
    width: ${lengthPercent};
    ${variant === 'default'
      ? `background-color: ${skeletonBackground}`
      : `background-color: ${LinkHeaderColor}`}
  `;
});

StyledLineSkeleton.defaultProps = defaultThemeProp;

const LineSkeleton: FunctionComponent<LineSkeletonProps & ForwardProps> = (
  props: LineSkeletonProps
) => {
  return <StyledLineSkeleton {...props} aria-disabled />;
};

LineSkeleton.defaultProps = defaultProps;

export default LineSkeleton;
